// "Draft a reply" entry points — build a prompt with the record's context and land it in
// Copilot, which auto-sends anything arriving via ?ask=.
const clip = (s, n) => { const t = (s || "").replace(/\s+/g, " ").trim(); return t.length > n ? `${t.slice(0, n - 1)}…` : t; };

export const copilotAskUrl = (prompt) => `/dashboard/copilot?ask=${encodeURIComponent(prompt.slice(0, 1800))}`;

export function feedbackReplyPrompt(f) {
  const who = f.name || "a resident";
  const via = f.source === "voice" ? "by phone" : f.source === "portal" ? "in the resident portal" : f.source === "sms" ? "by text" : "in the dashboard";
  const said = clip(f.verbatim && f.verbatim !== f.message ? f.verbatim : f.message, 600);
  const ch = f.phone ? "It will go out as a text message, so keep it short and warm." : "It will go out as an email.";
  return `Draft a reply to ${who}'s feedback (shared ${via}). They said: "${said}". Thank them, answer or acknowledge the substance from our rules and documents, and say what happens next. ${ch}`;
}

export function ticketReplyPrompt(a, detail) {
  const who = a.resident || "the resident";
  const last = ((detail && detail.comments) || []).filter((c) => c.author_type === "resident").slice(-1)[0];
  const ref = a.ref || a.code || "";
  return `Draft a reply text to ${who} about their request${ref ? ` ${ref}` : ""}: "${clip(a.title || a.summary, 160)}". Details: "${clip(a.details, 500)}". Status: ${a.status || "open"}${a.category ? `, category ${a.category}` : ""}.${last ? ` Their latest message: "${clip(last.text || last.body, 300)}".` : ""} Acknowledge, say what we're doing and when they'll hear back. Short, warm, goes out as a text.`;
}

export function conversationReplyPrompt(conv, messages) {
  const who = conv.active_person_name || "the resident";
  const recent = (messages || []).slice(-6).map((m) => {
    const speaker = m.role === "user" || m.direction === "inbound" || m.from === "resident" ? who : "Us";
    return `${speaker}: ${clip(m.content || m.text || m.body, 220)}`;
  }).join(" | ");
  return `Draft my next reply in this text conversation with ${who}. Recent messages: ${recent}. Answer from our rules and documents, be warm and specific, and keep it text-message short.`;
}
